export const demographicConstants = {

    // REQUEST_ADD_DEMOGRAPHIC_DATA
    REQUEST_ADD_DEMOGRAPHIC_DATA: 'REQUEST_ADD_DEMOGRAPHIC_DATA',
    RECIEVE_ADD_DEMOGRAPHIC_DATA: 'RECIEVE_ADD_DEMOGRAPHIC_DATA',
    ERROR_ADD_DEMOGRAPHIC_DATA: 'ERROR_ADD_DEMOGRAPHIC_DATA',

    // REQUEST_UPDATE_DELETE_DEMOGRAPHIC_DATA
    REQUEST_UPDATE_DELETE_DEMOGRAPHIC_DATA: 'REQUEST_UPDATE_DELETE_DEMOGRAPHIC_DATA',
    RECIEVE_UPDATE_DELETE_DEMOGRAPHIC_DATA: 'RECIEVE_UPDATE_DELETE_DEMOGRAPHIC_DATA',
    ERROR_UPDATE_DELETE_DEMOGRAPHIC_DATA: 'ERROR_UPDATE_DELETE_DEMOGRAPHIC_DATA',

    // REQUEST_ADD_INDUSTRY_DATA
    REQUEST_ADD_INDUSTRY_DATA:'REQUEST_ADD_INDUSTRY_DATA',
    RECIEVE_ADD_INDUSTRY_DATA:'RECIEVE_ADD_INDUSTRY_DATA',
    ERROR_ADD_INDUSTRY_DATA:'ERROR_ADD_INDUSTRY_DATA',

}


// WEBPACK FOOTER //
// ./src/_constants/demographicData.constants.js